import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AppInfoService } from 'core/app-info/app-info.service';
import { NotificationType } from 'core/notification/notification-config.class';
import { NotificationService } from 'core/notification/notification.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { ImportItemsQuoteService } from 'src/app/modules/shared/import-quotes-and-orders/import-items-quote.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { InvoiceHeader } from '../entities/invoice-header-entity';
import { OrderTrackingComponent } from '../order-tracking/order-tracking.component';
import { InvoicesService } from '../services/invoices.service';

@Component({
  selector: 'app-invoice-view',
  templateUrl: './invoice-view.component.html',
  styleUrls: ['./invoice-view.component.scss'],
  standalone: false
})
export class InvoiceViewComponent implements OnInit {
  appStrings: AppLocalization;
  invoiceNumber: string;
  invoiceHeaderDetails: InvoiceHeader;
  customerId: string;
  leadId: string;
  private dialogWidth = '600px';
  isAccountDetails = true;
  loading = {
    invoiceHeader: false,
    trackingInformation: false
  };
  importQuoteActive = false;
  isMobile = false;
  breadcrumbs = [];

  constructor(
    private appInfoService: AppInfoService,
    private invoicesService: InvoicesService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private invoiceService: InvoicesService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private importItemsQuoteService: ImportItemsQuoteService,
    private deviceService: DeviceDetectorService
  ) { }

  ngOnInit() {
    this.isMobile = this.deviceService.isMobile();
    this.leadId = this.activatedRoute.snapshot.params['leadId'];
    this.appStrings = this.appInfoService.appStrings;
    this.invoiceNumber = this.activatedRoute.snapshot.params['invoiceNumber'];
    const customerFromURL = this.activatedRoute.snapshot.params['customerId'];
    if (customerFromURL === 'null') {
      this.isAccountDetails = false;
    } else {
      this.isAccountDetails = true;
      this.customerId = customerFromURL;
    }

    this.loading.invoiceHeader = true;
    this.invoiceService.getInvoiceHeader(this.invoiceNumber,
      invoiceHeaderResult => {
        this.invoiceHeaderDetails = invoiceHeaderResult;
        this.loading.invoiceHeader = false;
      });

    this.importQuoteActive = !!this.importItemsQuoteService.getDestinationQuoteId();
    this.breadcrumbs = this.getBreadcrumbs();
  }

  close() {
    if(this.isAccountDetails){
      this.goBack();
    } else {
      this.router.navigate(['/invoices']);
    }
  }

  goBack() {
    this.router.navigate(['/accounts', this.customerId]);
  }

  /**
   * Prints an invoice
   * @param invoiceNumber - the invoice number
   */
  printInvoice(invoiceNumber: string) {
    this.invoicesService.printInvoice(invoiceNumber);
  }

  /**
   * Tracks an invoice by opening a tab with google search query
   */
  trackInvoice() {
    if (!this.invoiceHeaderDetails.orderNumber.trim().length) {
      this.notificationService.showNotification(this.appStrings.invoice_trackingNoOrderNumber, NotificationType.Error);
      return;
    }
    this.loading.trackingInformation = true;
    this.invoiceService.getInvoiceTrackingNumberList(this.invoiceHeaderDetails.orderNumber)
      .subscribe(orderTrackingList => {
        this.displayTrackingOrdersDialog(orderTrackingList);
        this.loading.trackingInformation = false;
      });
  }

  private displayTrackingOrdersDialog(orderTrackingList) {
    this.dialog.open(OrderTrackingComponent, {
      width: this.dialogWidth,
      data: {
        orderTrackingList,
        orderNumber: this.invoiceHeaderDetails.orderNumber
      }
    });
  }

  getBreadcrumbs(): any[] {
    const baseRoute = this.customerId ? '/accounts' : '/accounts-leads';
    const accountId = this.customerId || this.leadId;

    return [
      {
        label: this.appStrings.contacts_accountDetails,
        icon: this.isMobile ? 'arrow_back' : null,
        url: [baseRoute, accountId, { tab: 'invoices' }]
      },
      {
        label: this.appStrings.menu_Invoices,
      }
    ];
  }
}
